import { render } from "./WithdrawalSettings.vue.js?vue&type=template&id=cd46b07a!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./WithdrawalSettings.vue?vue&type=template&id=cd46b07a"
import script from "./WithdrawalSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./WithdrawalSettings.vue?vue&type=script&lang=js"
export * from "./WithdrawalSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./WithdrawalSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/digital-wallet/WithdrawalSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd46b07a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd46b07a', __exports__)) {
    api.reload('cd46b07a', __exports__)
  }
  
  module.hot.accept("./WithdrawalSettings.vue.js?vue&type=template&id=cd46b07a!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./WithdrawalSettings.vue?vue&type=template&id=cd46b07a", () => {
    api.rerender('cd46b07a', render)
  })

}


export default __exports__